import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Quizzes/PageProvider';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Button, IconButton, ResponsiveDialog, Stack, Text } from 'shell/components';

const ImportQuizDialog = () => {
    const { device } = useViewport();
    const { t } = useTranslation('quiz');
    const {
        canManageQuizzes,
        importDialogOpen,
        lmsQuizzes,
        selectedQuiz,
        setSelectedQuiz,
        loadingQuizzes,
        importingQuiz,
        quizListFailed,
        closeImportDialog,
        onImportQuiz,
    } = useContext(PageContext);
    const options = useMemo(() => lmsQuizzes.map((quiz) => ({ key: quiz.id, value: quiz.title })), [lmsQuizzes]);

    return (
        <ResponsiveDialog
            open={importDialogOpen && canManageQuizzes}
            aria-labelledby={'import-quiz-title'}
            PaperProps={{ role: 'dialog', 'aria-modal': true, 'aria-labelledby': 'import-quiz-title' }}
            onClose={closeImportDialog}
            sx={{
                '& .MuiDialog-paper': { width: 600, maxWidth: 'calc(100% - 32px)', borderRadius: 4 },
            }}
        >
            <Stack spacing={device === 'mobile' ? 5 : 8}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                    <Text id={'import-quiz-title'} component={'h2'} variant={'sh1'} weight={'semibold'}>
                        {t('import.title', 'Select a Quiz to Import')}
                    </Text>
                    <IconButton
                        aria-label={t('common:controls.close', 'Close')}
                        kind={'exit'}
                        size={'medium'}
                        tooltip={{ component: t('common:controls.close', 'Close') }}
                        variant={'square'}
                        sx={{ flexShrink: 0 }}
                        onClick={closeImportDialog}
                    />
                </Stack>
                <Autocomplete
                    id={'import-quiz-name'}
                    disableClearable
                    label={t('import.quiz-name', 'Quiz Name')}
                    options={options}
                    placeholder={t('common:ui.select', 'Select')}
                    required
                    value={options.find(({ key }) => key === selectedQuiz?.id) || null}
                    onChange={(_, option) => {
                        setSelectedQuiz(lmsQuizzes.find(({ id }) => id === option?.key) || null);
                    }}
                />
                {!loadingQuizzes && !quizListFailed && !options.length && (
                    <Text role={'status'}>
                        {t('import.empty', 'No quizzes are available to import from your LMS.')}
                    </Text>
                )}
                <Button
                    disabled={!selectedQuiz || loadingQuizzes || importingQuiz}
                    loading={importingQuiz}
                    sx={{ alignSelf: 'flex-end' }}
                    onClick={onImportQuiz}
                >
                    {t('common:controls.import', 'Import')}
                </Button>
            </Stack>
        </ResponsiveDialog>
    );
};

export default ImportQuizDialog;
